import { render, staticRenderFns } from "./housekeepingArea.vue?vue&type=template&id=04ed797a&"
import script from "./housekeepingArea.vue?vue&type=script&lang=js&"
export * from "./housekeepingArea.vue?vue&type=script&lang=js&"
import style0 from "./housekeepingArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports